import {Component, EventEmitter, Output } from "@angular/core";
import { TCITenantSelectorType } from "@tci/common";
import { AbstractTCITenantComponent } from "../../ng-tenant/tci-tenant-component";
import { BaseConnectionMenuComponentInput, BaseConnectionMenuComponentOutput } from "../ng-connections-menu";
import { ITCIConnectionsMenuOutput } from "../../ng-tenant/tci-tenant-components";

@Component({
    selector: TCITenantSelectorType.TCI_CONN_MENU_CHANGE_VISIBILITY.toString(),
    templateUrl: "./base-connection-change-visibility.component.html",
    styleUrls: ["./base-connection-change-visibility.component.less"]
})
export class BaseConnectionChangeVisibilityComponent
    <E, I extends BaseConnectionMenuComponentInput, O extends BaseConnectionMenuComponentOutput<ITCIConnectionsMenuOutput>>
    extends AbstractTCITenantComponent<E, I, EventEmitter<ITCIConnectionsMenuOutput>>  {

    @Output() output: EventEmitter<ITCIConnectionsMenuOutput> = new EventEmitter();
    errorMessage: string;

    constructor() {
        super();
    }

    /**
     * cancel and close modal
     */
    onCancel() {
        this.closeModal();
    }

    protected closeModal(refresh = false): ITCIConnectionsMenuOutput {
        this.errorMessage = undefined;
        const e: ITCIConnectionsMenuOutput = {
            closeModal: true,
            refresh
        };
        this.output.emit(e);
        return e;
    }

    /**
     * Implement this method for change action
     */
    changeVisibility(): void {
    }
}

